var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceIcon2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M15.907 20 22 14.84l-6.093-5.161v2.064h-3.351V10.4h-7.5v1.342a5.9 5.9 0 0 0 5.857 5.9l4.994.036z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#service-icon-2_svg__a)",
  fillRule: "evenodd",
  d: "M8.29 4 2 9.161l3.333 2.44.207.142L8.25 13.6v-1.857h7.656V9.678l3.35 2.838h.04a6.194 6.194 0 0 0-6.193-6.193H8.29z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-icon-2_svg__a",
  x1: 19.222,
  x2: 6.576,
  y1: 5.6,
  y2: 13.248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F8FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568DFE"
})))));
export default SvgServiceIcon2;